var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import isEqual from 'lodash/isEqual';
import { BILoggerContext } from './BILoggerContext';
import { BILogger } from './BILoggerRenderProp';
var BILoggerProvider = /** @class */ (function (_super) {
    __extends(BILoggerProvider, _super);
    function BILoggerProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BILoggerProvider.prototype.render = function () {
        return (React.createElement(BILoggerContext.Provider, { value: this.props.logger }, this.props.children));
    };
    return BILoggerProvider;
}(React.Component));
export { BILoggerProvider };
var BILoggerDefaults = /** @class */ (function (_super) {
    __extends(BILoggerDefaults, _super);
    function BILoggerDefaults(props) {
        var _this = _super.call(this, props) || this;
        _this._latestDefaults = null;
        if (!props.defaults) {
            console.warn("\uD83D\uDE15 Seems like you're using `BILoggerDefaults`, but didn't specify `defaults` property.\nPlease pass an object with BI defaults, so all nested BILogger HOCs will include it to events.");
        }
        return _this;
    }
    BILoggerDefaults.prototype.shouldUpdateDefaults = function () {
        var result = !!this.props.defaults &&
            !isEqual(this.props.defaults, this._latestDefaults);
        this._latestDefaults = this.props.defaults;
        return result;
    };
    BILoggerDefaults.prototype.render = function () {
        var _this = this;
        return (React.createElement(BILogger, null, function (bi) {
            if (_this.shouldUpdateDefaults()) {
                bi.util.updateDefaults(_this.props.defaults);
            }
            return (React.createElement(BILoggerContext.Provider, { value: bi }, _this.props.children));
        }));
    };
    return BILoggerDefaults;
}(React.Component));
export { BILoggerDefaults };
//# sourceMappingURL=BILoggerProvider.js.map